import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgGenericPipeModule } from 'ng-generic-pipe';

@Component({
  selector: 'app-diaries-card',
  standalone: true,
  imports: [CommonModule, NgGenericPipeModule],
  templateUrl: './diaries-card.component.html',
  styleUrl: './diaries-card.component.scss',
})
export class DiariesCardComponent {
  @Input() reviews: any = [];

  constructor(private sanitizer: DomSanitizer) {}

  getReviewText(text: string) {
    const safeHtml = this.sanitizer.bypassSecurityTrustHtml(text);
    return safeHtml;
  }
}
